
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PrivateAppointmentEditor.html?raw';
import topic from 'dojo/topic';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';

import { PrivateAppointmentFormBase, PrivateAppointmentTypes } from "../_loadingHelpers/PrivateAppointment";
import "../PrivateAppointmentEditor/Base/PrivateAppointmentFormBase";

import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { ToasterHelpers } from "../../more/Helpers";

class PrivateAppointmentEditor extends compose(_TabEnabledMixin, _StatefulSection) {
    templateString: any = template;

    private formContainer: HTMLElement;
    private baseForm: MdsLax<InstanceType<typeof PrivateAppointmentFormBase>>;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private entity: PrivateAppointmentTypes.PrivateAppointment_Extended;
    private readonly: boolean = true;

    _request: any = null;

    private selfSetup() {

        if (this.isStarted) return;
        if (this.isEmbeddedInTab == true || this.dlg || this.domNode.parentNode) return; // setup war schon
        let id = this.entityId ? this.entityId : (Math.random() * 10000).toString();

        // das Widget versucht hier, sich als Tab anzumelden
        this.createNewTabbedContent({
            enableClosing: true,
            label: this.entity && this.entityId ? this.entity.description ? this.entity.description : this.translations["General_Label_PrivateAppointment"] : this.translations["PrivateAppointmentEditor__CreateNew"],
            name: id,
            sidebarEntryName: id,
            widget: this,
            iconclass: "fas fa-edit"
        }, true);

        // falls das nicht gelingt, wird ein Dlg erzeugt:
        if (this.isEmbeddedInTab) {



            //this.requestTabswitch(this.internalName);
        } else {
            this.dlg = new GenericDialog();

            this.dlg.keepOpen = true;

            this.dlg.show(
                this.formContainer,
                this.translations["PrivateAppointmentEditor_dialogHeader"],
                null,
                null,
                "saveclose",
                lang.hitch(this, this._onDlgResult)
            );

            this.dlg.on("closed", lang.hitch(this, this._onDlgClosed));
            this.dlg.addButton("save", this.translations["General_Save"], lang.hitch(this, this.saveData), null, "accentBG", "fas fa-save", false, "first");
            this.dlg.disableButton("save");
        }
    }

    private _onDlgResult(result: number) {
        if (result <= 0) {

            this.dlg.close(-1, true);
        }
    }

    private _onDlgClosed(result: any) {
        this.emit("closed");
    }

    onDirtyChange(dirtyState: boolean) {
        let isNew = this.entityId == null;

        if (this.isEmbeddedInTab) {
            this.createDefaultButton("save", lang.hitch(this, this.saveData))

            this.requestContextButtonDisable("save", dirtyState);
            this.requestContextButtonDisable("rollback", dirtyState && !isNew);

        } else if (this.dlg) {
            dirtyState ? this.dlg.enableButton("save") : this.dlg.disableButton("save");
            !isNew && dirtyState ? this.dlg.enableButton("rollback") : this.dlg.disableButton("rollback");
        }
    }

    private saveData(): boolean {
        if (this._request != null) {
            return false;
        }

        if (this.checkMandatoryInputs() != true) {
            this.showToast({
                title: this.translations["General_MandatoryMissing"],
                iconClass: ToasterHelpers.ToasterIcons.warning
            });
            return false;
        }

        this.StandbyStart(this.formContainer);
        if (this.dlg) this.dlg.disableButton("save");

        setTimeout(lang.hitch(this, this.continueSaveData), 350); // onchangeds abwarten :-/

        return true;
    }

    private continueSaveData() {

        let data = lang.clone(this.changedData) as PrivateAppointmentTypes.PrivateAppointment_Extended;

        // Zeitzonen entfernen.
        if (data.date_start) {
            data.date_start = this.dateToLocalISOString(data.date_start) as any;
        }

        if (data.date_end) {
            data.date_end = this.dateToLocalISOString(data.date_end) as any;
        }

        if (this.entityId) data.ID = this.entityId;

        if (this.hasUserRole("_DEV")) console.log(this.id + " saveData:", data, this.changedData);


        this._request = this.RequestManager.callfunction(
            "Webtool_API_PrivateAppointment__SaveFormData",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError));

    }

    private _onSaveDataResponse(response) {
        this._request = null;
        //this.StandbyStop();

        if (response.ID) {
            this.showToast({
                title: this.translations["General_SavingSuccessful"],
                iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
                options: {
                    ID: this.entityId
                }
            });

            this.emit("saved", response);
            //topic.publish("EvBooking/Saved", response);
            topic.publish("PrivateAppointment/Saved", response); //TODO - SUBSCRIPTION MAIN PROPERTIES!!

            if (this._destroyed) return;
            this.resetDirty();
            this.loadEntityById(response.ID);

        } else {
            alert(this.id + " - unexpected response after saving: " + response);
            this.StandbyStop();
            if (this.dlg) this.dlg.enableButton("save");
        }
    }

    private _onSaveDataError(error: more.requestErrorMessage) {
        this._request = null;
        this.StandbyStop();
        if (this.dlg) this.dlg.enableButton("save");

        this.showToast({
            title: this.translate("General_SavingFailed"),
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message,
            options: {
                ID: this.entityId,
                timeout: 20000,
                closeButton: true
            }
        });
    }

    setEntity(entity: PrivateAppointmentTypes.PrivateAppointment_Extended) {
        this.setData(entity);
    }

    setData(entity) {

        if (!entity) return;

        let id = entity.ID;
        if (id != this.entityId) this.isPrivilegesLoaded = false;

        this.entity = entity;
        this.entityId = id;

        //entity["LEGACY"] = {}; // garned so geil, dann gibts auf der Legacy-Data dieses Legacy-Property auch wieder, aber ohne Inhalt.

        if (!this.isPrivilegesLoaded) {
            // Abzweigen: erst mal asynchron Rechte checken. dann kommen wir wieder her
            this.webPrivilegeManager.loadPrivilegesForEntity(this.entityId ? this.entity : null, lang.hitch(this, this._onPrivilegesLoaded));

            return;
        }
        this.selfSetup();
        super.setData.apply(this, arguments as any);
    }

    afterSetData() {
        let data = this.sourceData as PrivateAppointmentTypes.PrivateAppointment_Extended;
        if (this.entityId) {
            this.requestTabRename(data.description);
            if (this.isEmbeddedInTab) {
                if (this.hasUserRole("PrivateAppointment_Handle", null, data)) {
                    this.createDefaultButton("deleteWithConfirmationDlg", lang.hitch(this, this.deletePrivateAppointment));
                }
            }

            else if (this.dlg) {
                this.dlg._setHeaderAttr(data.description);

                if (this.hasUserRole("PrivateAppointment_Handle")) {

                }
            }
        }
    }

    reloadEntity(): void {
        this.loadEntityById(this.entityId);
    }

    loadEntityById(entityId: string): void {

        this.entityId = entityId;

        if (!this.entityId) return;

        this.startup();

        this.isPrivilegesLoaded = false;

        this.StandbyStart(this.formContainer);

        this.disableNode(this.formContainer);

        if (this._request != null) {
            this._request.cancel();
        }

        this.setStartupState("loading");

        let data = { ID: entityId };

        this._request = this.RequestManager.callfunction("Webtool_API_PrivateAppointment__GetEntityById",
            data,
            lang.hitch(this, this._onLoadEntityByIdResult),
            lang.hitch(this, function (err: more.requestErrorMessage) {
                this.StandbyStop();
                this._request = null;
                if (err && err.Message) {
                    alert(err.Message);
                } else {
                    console.log(err);
                }
            })
        );
    }

    private _onLoadEntityByIdResult(response: PrivateAppointmentTypes.PrivateAppointment_Extended): void {

        if (this._destroyed) return;

        this.disableNode(this.formContainer, false);
        this._request = null;
        this.setEntity(response);

        this.StandbyStop();
    }

    private deletePrivateAppointment() {
        if (!this.hasUserRole("PrivateAppointment_Handle")) return;

        if (!this.entity || !this.entity.ID) {
            return;
        }

        this.StandbyStart();

        let data = {
            entityID: this.entity.ID
        };

        let url = window.appRoot + "PrivateAppointmentEditor/DeletePrivateAppointment";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeletePrivateAppointmentResponse),
            lang.hitch(this, this._onDeletePrivateAppointmentError),
            false // sync
        );
    }

    private _onDeletePrivateAppointmentResponse(response: { Exception: boolean, Message: string }) {

        this.StandbyStop();

        this.showToast({
            title: this.translations["General_DeletingSuccessful"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        if (this.isEmbeddedInTab) {
            this.closeTab();
        }

        this.emit("entityDeleted");
    }

    private _onDeletePrivateAppointmentError(error: more.requestErrorMessage) {
        this.StandbyStop();

        let dlg = new GenericDialog();
        dlg.show(error.Message,
            this.translations["General_DeletingFailed"],
            null, ToasterHelpers.ToasterIcons.error, "close");
    }

    private _onPrivilegesLoaded() {
        this.isPrivilegesLoaded = true;

        this._handlePrivileges();

        this.setData(this.entity);
    }

    private _enableEdit(enable: boolean) {
        if (this.isEmbeddedInTab) {

            if (enable) {
                this.createDefaultButton("save", lang.hitch(this, this.saveData), false);
                this.createDefaultButton("rollback", lang.hitch(this, this.rollback), false);
                this.createDefaultButton("reload", lang.hitch(this, this.reloadEntity), true);
            }
        }

        this.disableNode(this.formContainer, !enable);

        this.readonly = !enable;
    }

    private _handlePrivileges() {

        this.hasUserRole("PrivateAppointment_Handle", lang.hitch(this, this._enableEdit), this.entity);
    }
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.displaynameProperty = "description";
        this.RequestManager.handleAs = "jsonWithDate";
    }
    startup(): void {
        if (this.isStarted) return;
        super.startup.apply(this, arguments as any);

        this.selfSetup();        

        this.isStarted = true;

        if (!this.entityId) this._handlePrivileges();
    }
    private isStarted: boolean = false;
    private isPrivilegesLoaded: boolean = false;
}

export default mdsWidget(PrivateAppointmentEditor);